import { AgentProfileResponseDto } from '@shared/services/apiService';
import { AddAgentPromptFormValue } from './types';

export const mapAPResponseDtoToFormValue = (
  data: AgentProfileResponseDto | undefined,
): AddAgentPromptFormValue | undefined => {
  if (!data) {
    return data;
  }
  return {
    name: data.name,
    prompt: data.prompt || '',
    firstMessage: data.firstMessage ?? '',
    firstMessageInterruptionsEnabled: data.firstMessageInterruptionsEnabled ?? false,
  };
};
